import React from 'react'
import { Col } from 'react-flexbox-grid'
import { useFormState, useFormApi } from 'informed'
import { useTranslation } from 'react-i18next'
import isIP from 'validator/lib/isIP'
import { Text, Checkbox, Select } from 'components/forms'

import { RoomSelector } from '../../CashRegister/Kasse'
import { sunmiCloudPrintersQuery } from './Printers'
import { HighlightedRow, SCheckbox } from './styled'

const PrinterRecord = ({ printer, designProject }) => {
	const [t] = useTranslation()
	const formApi = useFormApi()
	const formState = useFormState()

	const { value: name, dbIndex: position } = printer
	const { type, isActive } = formState.values.parameters?.printer?.locations?.find(el => el?.position === printer.dbIndex) || {}

	return(
		<HighlightedRow key={printer.position}>
			<Col xs={1} style={{ alignSelf: 'center' }}>
				<h4 style={{ fontWeight: '500' }}>{name}</h4>
			</Col>
			<Col xs={3} style={{ alignSelf: 'center' }}>
				<SCheckbox
					field={`parameters.printer.locations[${position}].isActive`}
					label={t('options_section.strings.active')}
					onChange={(e) => {
						formApi.setValue(`parameters.printer.locations[${position}].isDirectConnected`, e.target.checked)
						if(!e.target.checked) {
							formApi.setError(`parameters.printer.locations[${position}].type`, null)
							formApi.setError(`parameters.printer.locations[${position}].kdsHardwareId`, null)
							formApi.setError(`parameters.printer.locations[${position}].ip`, null)
						}
					}}
				/>
				<SCheckbox
					field={`parameters.printer.locations[${position}].copyForWaiter`}
					label={t('options_section.strings.copy_for_waiter')}
					readOnly={!isActive}
				/>
				<SCheckbox
					field={`parameters.printer.locations[${position}].tableShiftReceipt`}
					label={t('options_section.strings.table_shift_receipt')}
					readOnly={!isActive}
				/>
			</Col>
			<Col xs={4}>
				<Select
					field={`parameters.printer.locations[${position}].type`}
					options={[
						{ label: 'Epson M30', value: 'local_printer' },
						{ label: 'SUNMI_CLOUD by IP', value: 'sunmi' },
						{ label: 'SUNMI_CLOUD by Server', value: 'sunmi_cloud' }
					]}
					isClearable
					onChange={v => {
						formApi.setValue(`parameters.printer.locations[${position}].ip`, null)
						formApi.setError(`parameters.printer.locations[${position}].ip`, null)
						formApi.setError(`parameters.printer.locations[${position}].kdsHardwareId`, null)
					}}
					label={t('options_section.strings.printer')}
					readOnly={!isActive}
					validateOnChange
					validate={(v, vals) => {
						const currentPrinterValues = vals.parameters?.printer?.locations?.[position]
						if(!currentPrinterValues.isActive) {
							return null
						}
						if(!v && !currentPrinterValues.kdsHardwareId) {
							return t('validators.required')
						}
					}}
				/>
				<Select
					label={t('options_section.strings.kitchen_printer_serial_number')}
					field={`parameters.printer.locations[${position}].kdsHardwareId`}
					remoteOptions={{
						query: sunmiCloudPrintersQuery,
						variables: { software: 'KDS' },
						fetchPolicy: 'cache-and-network'
					}}
					onChange={() => {
						formApi.setError(`parameters.printer.locations[${position}].type`, null)
					}}
					isClearable
					startFromId={false}
					valueField='hardwareId'
					labelField='hardwareId'
					readOnly={!isActive}
					validateOnChange
					validate={(v, vals) => {
						const currentPrinterValues = vals.parameters?.printer?.locations?.[position]
						if(!currentPrinterValues.isActive) {
							return null
						}
						if(!v && !currentPrinterValues.type) {
							return t('validators.required')
						}
					}}
				/>
				<Text
					field={`parameters.printer.locations[${position}].position`}
					label='Location position'
					readOnly
					hidden
				/>
				<Checkbox
					field={`parameters.printer.locations[${position}].isDirectConnected`}
					label='isDirectConnected'
					readOnly
					hidden
				/>
			</Col>
			<Col xs={4}>
				{(type === 'sunmi_cloud' || !type) &&
					<Select
						field={`parameters.printer.locations[${position}].ip`}
						label={t('options_section.strings.serial_number')}
						remoteOptions={{
							query: sunmiCloudPrintersQuery,
							variables: { model: 'SUNMI_CLOUD_PRINTER' },
							fetchPolicy: 'cache-and-network'
						}}
						startFromId={false}
						valueField='hardwareId'
						labelField='hardwareId'
						isClearable
						validate={(v, vals) => {
							const currentPrinterValues = vals.parameters?.printer?.locations?.[position]
							if(!currentPrinterValues.type || !currentPrinterValues.isActive) {
								return null
							}
							if(!v) {
								return t('validators.required')
							}
						}}
						validateOnChange
						readOnly={!isActive || !type}
					/>
				}
				{type !== 'sunmi_cloud' && type &&
					<Text
						field={`parameters.printer.locations[${position}].ip`}
						label={type === 'sunmi' ?
							t('options_section.strings.ip_address') :
							t('options_section.strings.serial_number')}
						validate={(v, vals) => {
							const currentPrinterValues = vals.parameters?.printer?.locations?.[position]
							if(!currentPrinterValues.type || !currentPrinterValues.isActive) {
								return null
							}
							if(!v) {
								return t('validators.required')
							}
							if(currentPrinterValues.type === 'sunmi' && !isIP(v)) {
								return t('validators.not_a_valid_ip_address')
							}
						}}
						validateOnChange
						readOnly={!isActive || !type}
					/>
				}

				{!!designProject &&
					<RoomSelector
						field={`parameters.printer.locations[${position}].roomIds`}
						label={t('options_section.strings.preset_room')}
						designProjectId={designProject}
						isMulti
						readOnly={!isActive}
					/>
				}
			</Col>
		</HighlightedRow>
	)
}

export default PrinterRecord
